import { Api } from 'models/services/api';
import { ReadIngredientCategoriesQuery } from 'models/services/graphql';

import { IngredientCategoryCollectionData } from '../collection';

type DataToRead = {
  businessId: string;
  nextToken?: string;
};

const RequestQuery = `
  query ReadIngredientCategories($businessId: ID!, $nextToken: String) {
    ${ReadIngredientCategoriesQuery}
  }
`;

type ResponseData = {
  data: {
    readIngredientCategories: IngredientCategoryCollectionData;
  }
}

class ReadCollectionGql {

  readonly result?: IngredientCategoryCollectionData;
  private readonly api: Api<ResponseData>;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToRead): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const result = api.response.data.readIngredientCategories;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, result, api });
  }

}

export { ReadCollectionGql };